import { CategoryView } from "@bitwarden/web-vault/app/models/view/category/category.view";
import { DEFAULT_CATEGORY_ID } from "@bitwarden/web-vault/app/models/constants/category.constants";

export function getSymmetricDifference<T>(userCategories: T[], chosenCategories: T[]): T[] {
  // console.log("array1: ", array1);
  // console.log("array2: ", array2);
  const existingCategoriesSet = new Set(userCategories); // Convert array1 to a Set for unique elements
  const alreadyChosenCategoriesSet = new Set(chosenCategories); // Convert array2 to a Set for unique elements

  // Find elements in array1 that are not in array2
  const notInChosenCategoriesSet: T[] = Array.from(existingCategoriesSet).filter(
    (item) => !alreadyChosenCategoriesSet.has(item),
  );

  // Find elements in array2 that are not in array1
  const notInExistingCategoriesSet: T[] = Array.from(alreadyChosenCategoriesSet).filter(
    (item) => !existingCategoriesSet.has(item),
  );

  // Combine the results and return as an array
  return [...notInChosenCategoriesSet, ...notInExistingCategoriesSet];
}

export function findCategoryById(categories: CategoryView[], cId: string) {
  if (!cId) {
    return null;
  }
  return categories.find((category) => category.id === cId);
}

export function findCategoryByName(categories: CategoryView[], cName: string) {
  return categories.find((category) => category.name === cName);
}

export function areArraysDifferent(a: string[], b: string[]): boolean {
  if (a.length !== b.length) {
    return true;
  }
  const bSet = new Set(b);
  return a.some((item) => !bSet.has(item));
}
